import React from 'react'

const SlickprevCircle = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            {...props}
        >
            <circle cx="18" cy="18" r="17.5" fill="white" stroke="black" />
            <path
                d="M26.9072 17.9994H9.09277M9.09277 17.9994C12.3727 17.9994 15.0309 15.4178 15.0309 12.2324M9.09277 17.9994C12.3727 17.9994 15.0309 20.581 15.0309 23.7664"
                stroke="black"
                strokeMiterlimit="10"
            />
        </svg>
    )
}

export default SlickprevCircle
